import { styled, StyledSelect } from '@raskrask-dk/rr-components'

export const StyledComplexCodeInputGroup = styled('div', {
    display: 'grid',
    gridAutoFlow: 'column',
    alignItems: 'start',
    gap: '$2',

    [`& ${StyledSelect}`]: {
        flexShrink: 0,
    },

    '@mobile': {
        flexDirection: 'column',
    },
})